var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('thumbnails',{attrs:{"file-models":_vm.fileModels,"product-file-models":_vm.productFileModels,"product-model":_vm.productModel}}),_c('dropzone',{on:{"uploaded":_vm.onUploaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }